import { render, staticRenderFns } from "./Nature.vue?vue&type=template&id=30405df9"
import script from "./Nature.vue?vue&type=script&lang=js"
export * from "./Nature.vue?vue&type=script&lang=js"
import style0 from "./Nature.vue?vue&type=style&index=0&id=30405df9&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports